(function () {
  'use strict';

  var MONEY_FORMAT = window.__jazzMoneyFormat || '${{amount}}';

  function stripTrailingZeros(str) {
    if (!str || typeof str !== 'string') return str;
    return str.replace(/\.00(?!\d)/g, '').replace(/,00(?!\d)/g, '');
  }

  function formatFromTemplate(cents) {
    var amount = (parseInt(cents, 10) || 0) / 100;
    var hasCents = Math.round(amount * 100) % 100 !== 0;
    var amountStr = hasCents ? amount.toFixed(2) : String(Math.round(amount));
    return MONEY_FORMAT.replace(/\{\{\s*amount\s*\}\}/, amountStr);
  }

  function formatMoney(cents) {
    var parsed = parseInt(cents, 10) || 0;
    var formatted;

    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      formatted = Shopify.formatMoney(parsed, MONEY_FORMAT);
    } else {
      formatted = formatFromTemplate(parsed);
    }

    return stripTrailingZeros(formatted);
  }

  var PRICE_SELECTORS = [
    '.money',
    '.product-price__current-price',
    '.product-price__old-price',
    '.product-card__price-item',
    '.product-card__price-item-old',
    '.horizontal-product-card__price',
    '.vertical-product-card__price',
    '.c-hotspot__price-current',
    '.c-hotspot__price-compare',
    '.c-sticky-add-to-cart__price',
    '.c-sticky-add-to-cart__compare-price',
    '.c-sticky-add-to-cart__save-label',
    '.c-product-modal__price',
    '.c-product-modal__compare-price',
    '.c-product-modal__select-price',
    '.c-product-modal__select-compare-price',
    '.c-product-modal__select-savings',
    '.c-recipe-card-price',
    '.cart-item__price',
    '.cart-item__old-price',
    '.cart-drawer__item-price',
    '.product-vo-price',
    '.product-vo-price-piece',
    '.addon_price',
    '.addon_compare_price',
    '.bundle_main_price',
    '[data-product-price]',
    '[data-price-current]',
    '[data-price-compare]'
  ].join(',');

  function stripPriceNodes(root) {
    var scope = root || document;
    if (!scope.querySelectorAll) return;

    scope.querySelectorAll(PRICE_SELECTORS).forEach(function (node) {
      if (node.childElementCount > 0) return;
      var text = node.textContent;
      if (!text) return;
      var stripped = stripTrailingZeros(text);
      if (stripped !== text) node.textContent = stripped;
    });
  }

  var stripScheduled = false;
  function scheduleStrip(root) {
    if (stripScheduled) return;
    stripScheduled = true;
    requestAnimationFrame(function () {
      stripScheduled = false;
      stripPriceNodes(root || document);
    });
  }

  window.stripTrailingZeros = stripTrailingZeros;
  window.formatMoney = formatMoney;

  document.addEventListener('DOMContentLoaded', function () {
    scheduleStrip();
  });

  document.addEventListener('shopify:section:load', function (event) {
    scheduleStrip(event.target);
  });

  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].type === 'childList' || mutations[i].type === 'characterData') {
          scheduleStrip();
          return;
        }
      }
    });

    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
  }
})();
